import { addDays, endOfDay, isWeekend } from "date-fns";

/**
 * Calculates the voting end date (end of the last working day).
 * Starts counting from the day after creation and skips weekends.
 */
export function calculateVotingEndDate(creationDate: Date, weekdaysCount: number = 1): Date {
    let voteDate = addDays(creationDate, 1); // start from the next day
    let countedDays = 0;

    while (countedDays < weekdaysCount) {
        if (!isWeekend(voteDate)) {
            countedDays += 1;
        }
        if (countedDays < weekdaysCount) {
            voteDate = addDays(voteDate, 1);
        }
    }

    return endOfDay(voteDate);
}
